//引入通用common
import commons from '@/util/commons.js';
import {apiImgs,apiCountries,apiItemstuijian,apiHuodong,apiJiangzuo,apiHxarticle,apiCountriesinfo,apiCountriestypes,apiCountriesitems,apiYuyue,apiCountrieslist,apiItemsinfo,
apiZhuantimenu,apiZhuantibanner,apiZhuantilist,apiVediobanner,apiVediomenu,apiVediolist,apiAssesslabel,apiAssess,apiItemslist,apiItemscost,apiZiliaocountrys,
apiFilefrom,apiDuibilabel,apiDuibi,apiDazhoulist,apiGuolist,apiTypelist,apiItems,apiDaohang,apiArticlenav,apiContent,apiSeo,apiMinizt,apiNumbers,		apiTheme,apiThemedetail,apiThememake,apiCate,apiSys,apiUserInfo,apiInspect,apiUserModify,apiBangdingModify,apiDizhiModify,apiPay,apiPayment,apiDiscount,apiUserorders,apiUsercancel,apiUserfinish,apiDesignlist,apiDeldesign,apiBookidsenCryption,apiRestoredesign,apiTeachlist,apiArticlelist,apiTeachcontent} from '@/request/api.js';
import {NProgress} from '@/util/nprogress.js'; // 顶部加载条组件
import * as types from '@/store/types.js';
import {EventBus} from '@/util/eventBus.js'; // 引入事件总线
export default {
	//获取验证码的状态处理
	apiLoginSms(ob,that){
		// NProgress.done();
		if(ob.state == 1001){
			//获取成功
			//开始倒计时
			that.number = 60;
			that.$message.showMsgBox({
	            type: 'success',
	            content: ob.message
	        });
		}else{
			//获取失败
			that.sms = true;
			that.$message.showMsgBox({
	            type: 'warning',
	            content: ob.message
	        });
		}
		this.sms = true;
		that.zhezhao = false;
	},
	//登录返回处理
	apiUserLogin(ob,that,store,type){
		NProgress.done();
		if(ob.state==1001){
			//执行写入本地
			var result = commons.saveTodos('localUser',{token:ob.data.token,path:ob.data.path,name:ob.data.name});
			// var result = true;
			if(result){
				//更新本地路由的登录信息
				store.commit(types.SAVE_LOCALUSER);
				//本地存储成功
				that.$message.showMsgBox({
		            type: 'success',
		            content: ob.message
		        });
		        clearInterval(that.timer);
		        if(type==1){
		        	//弹框登录
		        	setTimeout(()=>{
			        	that.visible = false;
			        },1000);
		        }else{
		        	//单页登录
		        	setTimeout(()=>{
			        	//跳转首页
		        		that.$router.push({ path: '/' });
			        },1000);
		        }
			}else{
				//获取失败
				that.loginState = true;
				that.$message.showMsgBox({
		            type: 'warning',
		            content: '本地存储失败'
		        });
			}
		}else{
			//获取失败
			that.loginState = true;
			that.$message.showMsgBox({
	            type: 'warning',
	            content: ob.message
	        });
		}
	},
	//获取个人信息
	getUserInfo(that){
		//执行获取个人信息的请求
		apiUserInfo({}).then(ob=>{
			if(ob.state==1001){
				that.userInfo = ob.data;
			}else{
				that.$message.showMsgBox({
		            type: 'warning',
		            content: ob.message
		        });
			}
		}).catch(ob=>{
			that.$message.showMsgBox({
	            type: 'warning',
	            content: '获取个人信息失败'
	        });
		});
	},
	//检测
	apiInspect(that,ob){
		return apiInspect(ob).then(ob=>{
			if(ob.state==1){
				//处理组件的名
				ob.data.listArr.map(item=>{
					item.arr.componentStr = [item.arr.module_head, item.arr.module_center, item.arr.module_tail].filter(item=>item).join('-'); //拼接组件名
					return item;
				});
				that.data = ob.data.listArr;
				that.isPay = ob.data.isPay;
			}else{
				that.$message.showMsgBox({
	                type: 'warning',
	                content: ob.message
	            });
			}
		}).catch(ob=>{
			that.$message.showMsgBox({
                type: 'warning',
                content: '网络错误'
            });
		});
	},
	//获取支付页面的数据
	apiPay(that,ob){
		return apiPay(ob).then(ob=>{
			if(ob.state==1){
				//处理组件的名
				ob.data.bookList.map(item=>{
					item.arr.componentStr = [item.arr.module_head, item.arr.module_center, item.arr.module_tail].filter(item=>item).join('-'); //拼接组件名
					return item;
				});
				that.bookList = ob.data.bookList;
				that.addressInfo = ob.data.addressInfo;
				that.discountList = ob.data.discountList;
				that.postage = ob.data.postage;
				that.minus = ob.data.minus;
			}else{
				that.$message.showMsgBox({
	                type: 'warning',
	                content: ob.message
	            });
			}
			return {state:ob.state,message:ob.message};
		}).catch(ob=>{
			that.$message.showMsgBox({
                type: 'warning',
                content: '网络错误'
            });
            return {state:5,message:'网络错误'};
		});
	},
	//支付页面 - 生成订单
	apiPayment(that,ob){
		return apiPayment(ob).then(ob=>{
			if(ob.state==1){
				//处理组件的名
				// that.closeNProgress(false);
			}else{
				that.$message.showMsgBox({
	                type: 'warning',
	                content: ob.message
	            });
	            that.closeNProgress(false);
	            that.enterPay = 1;
			}
		}).catch(ob=>{
			that.$message.showMsgBox({
                type: 'warning',
                content: '网络错误'
            });
            that.closeNProgress(false);
            that.enterPay = 1;
		});
	},
	//修改个人信息
	apiUserModify(obj,that){
		//执行获取个人信息的请求
		apiUserModify(obj).then(ob=>{
			if(ob.state==1001){
				//不可修改
				that.xinxiUpload = false;
				//更新本地头像
				var localUser = commons.readTodos('localUser');//获取本地
				localUser.path = obj.path;//更新头像
				localUser.name = obj.name;//更新姓名
				commons.saveTodos('localUser',localUser);//更新本地
				that.savelocaluser();//更新状态管理
				//提示
				that.$message.showMsgBox({
		            type: 'success',
		            content: ob.message
		        });
			}else{
				//提示
				that.$message.showMsgBox({
		            type: 'warning',
		            content: ob.message
		        });
			}
		}).catch(ob=>{
			//提示
			that.$message.showMsgBox({
	            type: 'warning',
	            content: '更新失败'
	        });
		});
		NProgress.done();
	},
	// 修改绑定
	apiBangdingModify(obj,that){
		//不可点击
		that.bangdingState = false;
		//执行获取个人信息的请求
		apiBangdingModify(obj).then(ob=>{
			if(ob.state==1001){
				//不可修改
				that.bangdingState = true;
				that.newphone = '';
				that.code = '';
				//提示
				that.$message.showMsgBox({
		            type: 'success',
		            content: ob.message
		        });
		        //将本地的改为最新的
		        that.userInfo.phone = obj.newphone;
		        //关闭定时器
		        clearInterval(that.timer);
		        //重置number
		        that.number = 0;
		        //验证码可点击
		        that.sms = true;
			}else{
				//提示
				that.$message.showMsgBox({
		            type: 'warning',
		            content: ob.message
		        });
		        that.bangdingState = true;
			}
		}).catch(ob=>{
			//提示
			that.$message.showMsgBox({
	            type: 'warning',
	            content: '更新失败'
	        });
	        that.bangdingState = true;
		});
		NProgress.done();
	},
	//修改地址
	apiDizhiModify(obj,that){
		//不可点击
		that.dizhiState = false;
		//执行获取个人信息的请求
		apiDizhiModify(obj).then(ob=>{
			if(ob.state==1001){
				//不可修改
				that.dizhiState = false;
				//提示
				that.$message.showMsgBox({
		            type: 'success',
		            content: ob.message
		        });
			}else{
				//提示
				that.$message.showMsgBox({
		            type: 'warning',
		            content: ob.message
		        });
		        that.dizhiState = true;
			}
		}).catch(ob=>{
			//提示
			that.$message.showMsgBox({
	            type: 'warning',
	            content: '更新失败'
	        });
	        that.dizhiState = true;
		});
		NProgress.done();
	},
	//修改地址
	apiOrderDizhiModify(obj,that){
		//执行获取个人信息的请求
		return apiDizhiModify(obj).then(ob=>{
			if(ob.state==1001 || ob.state==1004){
				return {state:true,message:ob.message};
			}else{
				return {state:false,message:ob.message};
			}
		}).catch(ob=>{
			return {state:false,message:'请求失败'};
		});
	},
	//获取我的优惠券
	apiDiscount(that,obj){
		//执行获取个人信息的请求
		return apiDiscount(obj).then(ob=>{
			if(ob.state==1){
				//请求成功
				return {state:1,message:'获取成功',data:ob.data};
			}else if(ob.state==2){
				//没有更多了
				return {state:2,message:'没有更多了',data:ob.data};
			}else{
				//获取失败
				return {state:4,message:ob.message};
			}
		}).catch(ob=>{
			return {state:4,message:'请求失败'};
		});
	},
	//取消订单
	apiUsercancel(that,obj,events){
		//加载中
		if(confirm('是否取消该订单')){
			EventBus.$emit('loadingFun',true);//遮罩
			that.is_zhezhao = true;
			var nodeChild = $($(events.target).find('span i').context);
			// console.log($($(events.target).find('span i').context).css('color','red'));
			$(nodeChild).addClass('xuanzhuan');//上传旋转
			var objArr = obj;
			//执行获取个人信息的请求
			return apiUsercancel(objArr).then(ob=>{
				if(ob.state==1){
					var result = that.saveData(objArr.order_id,ob.data.is_state);
					if(result){
						//提示
						that.$message.showMsgBox({
				            type: 'success',
				            content: '取消成功'
				        });
					}
				}else{
					//提示
					that.$message.showMsgBox({
			            type: 'warning',
			            content: ob.message
			        });
				}
				$(nodeChild).removeClass('xuanzhuan');//上传旋转
				that.is_zhezhao = false;
				EventBus.$emit('loadingFun',false);//遮罩
			}).catch(ob=>{
				$(nodeChild).removeClass('xuanzhuan');//上传旋转
				//提示
				that.$message.showMsgBox({
		            type: 'warning',
		            content: '操作失败'
		        });
		        that.is_zhezhao = false;
		        EventBus.$emit('loadingFun',false);//遮罩
			});
		}else{
		}
	},
	//确认收货
	apiUserfinish(that,obj,events){
		//加载中
		if(confirm('是否确认收货')){
			EventBus.$emit('loadingFun',true);//遮罩
			that.is_zhezhao = true;
			var nodeChild = $($(events.target).find('span i').context);
			// console.log($($(events.target).find('span i').context).css('color','red'));
			$(nodeChild).addClass('xuanzhuan');//上传旋转
			var objArr = obj;
			//执行获取个人信息的请求
			return apiUserfinish(objArr).then(ob=>{
				if(ob.state==1){
					var result = that.saveData(objArr.order_id,ob.data.is_state);
					if(result){
						//提示
						that.$message.showMsgBox({
				            type: 'success',
				            content: '取消成功'
				        });
					}
				}else{
					//提示
					that.$message.showMsgBox({
			            type: 'warning',
			            content: ob.message
			        });
				}
				$(nodeChild).removeClass('xuanzhuan');//上传旋转
				that.is_zhezhao = false;
				EventBus.$emit('loadingFun',false);//遮罩
			}).catch(ob=>{
				$(nodeChild).removeClass('xuanzhuan');//上传旋转
				//提示
				that.$message.showMsgBox({
		            type: 'warning',
		            content: '操作失败'
		        });
		        that.is_zhezhao = false;
		        EventBus.$emit('loadingFun',false);//遮罩
			});
		}else{
		}
	},
	//我的设计
	apiDesignlist(that,obj){
		//执行获取个人信息的请求
		return apiDesignlist(obj).then(ob=>{
			if(ob.state==1){
				//请求成功
				return {state:1,message:'获取成功',data:ob.data};
			}else if(ob.state==2){
				//没有更多了
				return {state:2,message:'没有更多了',data:ob.data};
			}else{
				//获取失败
				return {state:4,message:ob.message};
			}
		}).catch(ob=>{
			return {state:4,message:'请求失败'};
		});
	},
	//获取我的优惠券
	apiOrder(that,obj){
		//执行获取个人信息的请求
		return apiUserorders(obj).then(ob=>{
			if(ob.state==1){
				//请求成功
				return {state:1,message:'获取成功',data:ob.data};
			}else if(ob.state==2){
				//没有更多了
				return {state:2,message:'没有更多了',data:ob.data};
			}else{
				//获取失败
				return {state:4,message:ob.message};
			}
		}).catch(ob=>{
			return {state:4,message:'请求失败'};
		});
	},
	//删除我的设计
	apiDeldesign(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiDeldesign(obj).then(ob=>{
			return ob;
		}).catch(ob=>{
			return {state:1002,message:'请求失败'}
		});
	},
	apiRestoredesign(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiRestoredesign(obj).then(ob=>{
			return ob;
		}).catch(ob=>{
			return {state:1002,message:'请求失败'}
		});
	},
	//获取书本id加密集合 - 用于页面检测及支付页面
	apiBookidsenCryption(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiBookidsenCryption(obj).then(ob=>{
			return ob;
		}).catch(ob=>{
			return {state:2,message:'请求失败'}
		});
	},
	//请求优惠券信息
	apiUserDiscount(that,obj){
		//请求中
		that.loadingFun(1);
		//执行获取个人信息的请求
		return apiDiscount(obj).then(ob=>{
			if(ob.state==1){
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//请求成功了
					ob.data.list.forEach(item => {
						that.data.push(item);
					});
					that.allPage = ob.data.totalPages;//重置总页数
					that.page++;//多加一页
					that.is_empty = false;//为空
					that.loadingFun(2);//关闭加载动画
		        }
			}else if(ob.state==2){
				//没有更多了
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//没有任何数据
					that.allPage = ob.data.totalPages;//重置总页数
					that.is_empty = false;//为空
					that.loadingFun(3);//关闭加载动画 - 没有更多了(不再请求)
		        }
			}else{
				//请求失败
		        that.$message.showMsgBox({
		            type: 'warning',
		            content: '请求失败'
		        });
		        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
			}
			return ob;
		}).catch(ob=>{
			//请求失败
	        that.$message.showMsgBox({
	            type: 'warning',
	            content: '请求失败'
	        });
	        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
	        return ob;
		});
	},
	//电脑端我的订单
	apiUserOrder(that,obj){
		//请求中
		that.loadingFun(1);
		//执行获取个人信息的请求
		return apiUserorders(obj).then(ob=>{
			if(ob.state==1){
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//请求成功了
					ob.data.list.forEach(item => {
						that.data.push(item);
					});
					that.allPage = ob.data.totalPages;//重置总页数
					that.page++;//多加一页
					that.is_empty = false;//为空
					that.loadingFun(2);//关闭加载动画
		        }
			}else if(ob.state==2){
				//没有更多了
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//没有任何数据
					that.allPage = ob.data.totalPages;//重置总页数
					that.is_empty = false;//为空
					that.loadingFun(3);//关闭加载动画 - 没有更多了(不再请求)
		        }
			}else{
				//请求失败
		        that.$message.showMsgBox({
		            type: 'warning',
		            content: '请求失败'
		        });
		        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
			}
			return ob;
		}).catch(ob=>{
			//请求失败
	        that.$message.showMsgBox({
	            type: 'warning',
	            content: '请求失败'
	        });
	        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
	        return ob;
		});
	},
	apiUserDesign(that,obj){
		//请求中
		that.loadingFun(1);
		//执行获取个人信息的请求
		return apiDesignlist(obj).then(ob=>{
			if(ob.state==1){
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//请求成功了
					ob.data.list.forEach(item => {
						that.data.push(item);
					});
					that.allPage = ob.data.totalPages;//重置总页数
					that.page++;//多加一页
					that.is_empty = false;//为空
					that.loadingFun(2);//关闭加载动画
		        }
			}else if(ob.state==2){
				//没有更多了
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//没有任何数据
					that.allPage = ob.data.totalPages;//重置总页数
					that.is_empty = false;//为空
					that.loadingFun(3);//关闭加载动画 - 没有更多了(不再请求)
		        }
			}else{
				//请求失败
		        that.$message.showMsgBox({
		            type: 'warning',
		            content: '请求失败'
		        });
		        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
			}
			return ob;
		}).catch(ob=>{
			//请求失败
	        that.$message.showMsgBox({
	            type: 'warning',
	            content: '请求失败'
	        });
	        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
	        return ob;
		});
	},
	//教程列表
	apiTeach(that,obj){
		//请求中
		that.loadingFun(1);
		//执行获取个人信息的请求
		return apiTeachlist(obj).then(ob=>{
			if(ob.state==1001){
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//请求成功了
					ob.data.list.forEach(item => {
						that.data.push(item);
					});
					that.allPage = ob.data.totalPages;//重置总页数
					that.page++;//多加一页
					that.is_empty = false;//为空
					that.loadingFun(2);//关闭加载动画
		        }
			}else if(ob.state==1004){
				//没有更多了
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//没有任何数据
					that.allPage = ob.data.totalPages;//重置总页数
					that.is_empty = false;//为空
					that.loadingFun(3);//关闭加载动画 - 没有更多了(不再请求)
		        }
			}else{
				//请求失败
		        that.$message.showMsgBox({
		            type: 'warning',
		            content: '请求失败'
		        });
		        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
			}
			return ob;
		}).catch(ob=>{
			//请求失败
	        that.$message.showMsgBox({
	            type: 'warning',
	            content: '请求失败'
	        });
	        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
	        return ob;
		});
	},
	//主题队列
	apiTheme(that,obj){
		//请求中
		that.loadingFun(1);
		//执行获取个人信息的请求
		return apiTheme(obj).then(ob=>{
			if(ob.state==1001){
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//请求成功了
					ob.data.list.forEach(item => {
						that.data.push(item);
					});
					that.allPage = ob.data.totalPages;//重置总页数
					that.page++;//多加一页
					that.is_empty = false;//为空
					that.loadingFun(2);//关闭加载动画
		        }
			}else if(ob.state==1004){
				//没有更多了
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//没有任何数据
					that.allPage = ob.data.totalPages;//重置总页数
					that.is_empty = false;//为空
					that.loadingFun(3);//关闭加载动画 - 没有更多了(不再请求)
		        }
			}else{
				//请求失败
		        that.$message.showMsgBox({
		            type: 'warning',
		            content: '请求失败'
		        });
		        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
			}
			return ob;
		}).catch(ob=>{
			//请求失败
	        that.$message.showMsgBox({
	            type: 'warning',
	            content: '请求失败'
	        });
	        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
	        return ob;
		});
	},
	//教程列表
	apiArticle(that,obj){
		//请求中
		that.loadingFun(1);
		//执行获取个人信息的请求
		return apiArticlelist(obj).then(ob=>{
			if(ob.state==1001){
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//请求成功了
					ob.data.list.forEach(item => {
						that.data.push(item);
					});
					that.allPage = ob.data.totalPages;//重置总页数
					that.page++;//多加一页
					that.is_empty = false;//为空
					that.loadingFun(2);//关闭加载动画
		        }
			}else if(ob.state==1004){
				//没有更多了
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//没有任何数据
					that.allPage = ob.data.totalPages;//重置总页数
					that.is_empty = false;//为空
					that.loadingFun(3);//关闭加载动画 - 没有更多了(不再请求)
		        }
			}else{
				//请求失败
		        that.$message.showMsgBox({
		            type: 'warning',
		            content: '请求失败'
		        });
		        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
			}
			return ob;
		}).catch(ob=>{
			//请求失败
	        that.$message.showMsgBox({
	            type: 'warning',
	            content: '请求失败'
	        });
	        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
	        return ob;
		});
	},
	//获取教程的详情
	apiTeachcontent(that,obj){
		that.isLoading = 1;
		return apiTeachcontent(obj).then(ob=>{
			if(ob.state==1){
				that.title = ob.data.title;
				that.addtime = ob.data.addtime;
				that.content = ob.data.content;
				that.isLoading = 2;
			}else{
				//请求失败
		        that.$message.showMsgBox({
		            type: 'warning',
		            content: '请求失败'
		        });
				that.isLoading = 3;
			}
		}).catch(ob=>{
			//请求失败
	        that.$message.showMsgBox({
	            type: 'warning',
	            content: '请求失败'
	        });
	        that.isLoading = 3;
		});
	},
	//获取广告
	apiSys(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiSys(obj).then(ob=>{
			that.leftArr = ob.data.left;
			that.rightArr = ob.data.right;
		}).catch(ob=>{
			//请求失败
	        that.$message.showMsgBox({
	            type: 'warning',
	            content: '请求失败'
	        });
		});
	},
	//获取分类
	apiCate(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiCate(obj).then(ob=>{
			that.cate = ob.data.list;
		}).catch(ob=>{
			//请求失败
	        that.$message.showMsgBox({
	            type: 'warning',
	            content: '请求失败'
	        });
		});
	},
	//获取分类
	apiThemedetail(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiThemedetail(obj).then(ob=>{
			return {state:true,data:ob.data};
		}).catch(ob=>{
			return {state:false};
		});
	},
	//执行主题制作
	apiThememake(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiThememake(obj).then(ob=>{
			return ob;
		}).catch(ob=>{
			return {state:false};
		});
	},



	//获取首页轮播图片
	apiImgs(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiImgs(obj).then(ob=>{
			if(ob.state==1001){
				that.bannerArr = ob.data;
			}
			return ob;
		}).catch(ob=>{
			return {state:false};
		});
	},
	//获取首页轮播图片
	apiCountries(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiCountries(obj).then(ob=>{
			if(ob.state==1001){
				that.countriesArrs = ob.data;
			}
			return ob;
		}).catch(ob=>{
			return {state:false};
		});
	},
	//首页项目推荐
	apiItemstuijian(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiItemstuijian(obj).then(ob=>{
			if(ob.state==1001){
				that.tuijianItems = ob.data;
			}
			return ob;
		}).catch(ob=>{
			return {state:false};
		});
	},
	//首页活动日历
	apiHuodong(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiHuodong(obj).then(ob=>{
			if(ob.state==1001){
				that.huodongArr = ob.data;
			}
			return ob;
		}).catch(ob=>{
			return {state:false};
		});
	},
	//首页讲座推荐
	apiJiangzuo(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiJiangzuo(obj).then(ob=>{
			if(ob.state==1001){
				that.jiangzuoArr = ob.data;
			}
			return ob;
		}).catch(ob=>{
			return {state:false};
		});
	},
	//国家详情 apiCountriesinfo
	apiCountriesinfo(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiCountriesinfo(obj).then(ob=>{
			if(ob.state==1001){
				that.info = ob.data;
			}
			return ob;
		}).catch(ob=>{
			return {state:false};
		});
	},
	//国家项目的类别集合
	apiCountriestypes(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiCountriestypes(obj).then(ob=>{
			if(ob.state==1001){
				that.typesArr = ob.data;
			}
			return ob;
		}).catch(ob=>{
			return {state:false};
		});
	},
	//国家项目的类别集合
	apiCountriesitems(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiCountriesitems(obj).then(ob=>{
			if(ob.state==1001){
				that.itemsArr = ob.data.list;
			}
			return ob;
		}).catch(ob=>{
			return {state:false};
		});
	},
	//在线预约
	apiYuyue(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiYuyue(obj).then(ob=>{
			return ob;
		}).catch(ob=>{
			return {state:1002,message:'提交失败'};
		});
	},
	apiFilefrom(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiFilefrom(obj).then(ob=>{
			return ob;
		}).catch(ob=>{
			return {state:1002,message:'提交失败'};
		});
	},
	//在线评估
	apiAssess(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiAssess(obj).then(ob=>{
			return ob;
		}).catch(ob=>{
			return {state:1002,message:'提交失败'};
		});
	},
	//国家项目的类别集合
	apiCountrieslist(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiCountrieslist(obj).then(ob=>{
			if(ob.state==1001){
				that.countriesArr = ob.data;
			}
			return ob;
		}).catch(ob=>{
			return {state:false};
		});
	},
	//国家项目的类别集合
	apiItemslist(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiItemslist(obj).then(ob=>{
			if(ob.state==1001){
				that.itemsArr = ob.data.list;
			}
			return ob;
		}).catch(ob=>{
			return {state:false};
		});
	},
	//国家项目的类别集合
	apiItemsinfo(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiItemsinfo(obj).then(ob=>{
			if(ob.state==1001){
				that.info = ob.data;
			}
			return ob;
		}).catch(ob=>{
			return {state:false};
		});
	},
	//国家项目的类别集合
	apiZhuantibanner(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiZhuantibanner(obj).then(ob=>{
			if(ob.state==1001){
				that.bannerArr = ob.data;
			}
			return ob;
		}).catch(ob=>{
			return {state:false};
		});
	},
	//国家项目的类别集合
	apiZhuantimenu(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiZhuantimenu(obj).then(ob=>{
			if(ob.state==1001){
				that.guoArr = ob.data;
			}
			return ob;
		}).catch(ob=>{
			return {state:false};
		});
	},
	//国家项目的类别集合
	apiVediobanner(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiVediobanner(obj).then(ob=>{
			if(ob.state==1001){
				that.bannerArr = ob.data;
			}
			return ob;
		}).catch(ob=>{
			return {state:false};
		});
	},
	//国家项目的类别集合
	apiVediomenu(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiVediomenu(obj).then(ob=>{
			if(ob.state==1001){
				that.guoArr = ob.data;
			}
			return ob;
		}).catch(ob=>{
			return {state:false};
		});
	},
	//国家项目的类别集合
	apiAssesslabel(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiAssesslabel(obj).then(ob=>{
			if(ob.state==1001){
				that.info = ob.data;
			}
			return ob;
		}).catch(ob=>{
			return {state:false};
		});
	},
	//国家项目的类别集合
	apiItemscost(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiItemscost(obj).then(ob=>{
			return ob;
		}).catch(ob=>{
			return {state:false,message:'请求失败'};
		});
	},
	//国家项目的类别集合
	apiZiliaocountrys(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiZiliaocountrys(obj).then(ob=>{
			if(ob.state==1001){
				that.countryArr = ob.data;
			}
			return ob;
		}).catch(ob=>{
			return {state:false,message:'请求失败'};
		});
	},
	apiDuibilabel(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiDuibilabel(obj).then(ob=>{
			if(ob.state==1001){
				that.label = ob.data;
			}
			return ob;
		}).catch(ob=>{
			return {state:false,message:'请求失败'};
		});
	},
	apiDuibi(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiDuibi(obj).then(ob=>{
			return ob;
		}).catch(ob=>{
			return {state:false,message:'请求失败'};
		});
	},
	apiDazhoulist(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiDazhoulist(obj).then(ob=>{
			return ob;
		}).catch(ob=>{
			return {state:false,message:'请求失败'};
		});
	},
	apiGuolist(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiGuolist(obj).then(ob=>{
			return ob;
		}).catch(ob=>{
			return {state:false,message:'请求失败'};
		});
	},
	apiTypelist(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiTypelist(obj).then(ob=>{
			return ob;
		}).catch(ob=>{
			return {state:false,message:'请求失败'};
		});
	},
	apiMinizt(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiMinizt(obj).then(ob=>{
			return ob;
		}).catch(ob=>{
			return {state:false,message:'请求失败'};
		});
	},
	apiNumbers(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiNumbers(obj).then(ob=>{
			return ob;
		}).catch(ob=>{
			return {state:false,message:'请求失败'};
		});
	},
	apiDaohang(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiDaohang(obj).then(ob=>{
			return ob;
		}).catch(ob=>{
			return {state:false,message:'请求失败'};
		});
	},
	apiSeo(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiSeo(obj).then(ob=>{
			if(ob.state==1001){
				that.info = ob.data;
			}
			return ob;
		}).catch(ob=>{
			return {state:false,message:'请求失败'};
		});
	},
	apiArticlenav(that,obj){
		// that.loadingFun(true);
		//执行获取个人信息的请求
		return apiArticlenav(obj).then(ob=>{
			if(ob.state==1001){
				that.navArr = ob.data;
			}
			return ob;
		}).catch(ob=>{
			return {state:false,message:'请求失败'};
		});
	},
	//获取教程的详情
	apiContent(that,obj){
		that.isLoading = 1;
		return apiContent(obj).then(ob=>{
			if(ob.state==1){
				that.topic = ob.data.topic;
				that.addtime = ob.data.addtime;
				that.content = ob.data.content;
				that.isLoading = 2;
			}else{
				//请求失败
		        that.$message.showMsgBox({
		            type: 'warning',
		            content: '请求失败'
		        });
				that.isLoading = 3;
			}
		}).catch(ob=>{
			//请求失败
	        that.$message.showMsgBox({
	            type: 'warning',
	            content: '请求失败'
	        });
	        that.isLoading = 3;
		});
	},
	//主题队列
	apiHxarticle(that,obj){
		//请求中
		that.loadingFun(1);
		//执行获取个人信息的请求
		return apiHxarticle(obj).then(ob=>{
			if(ob.state==1001){
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//请求成功了
					ob.data.list.forEach(item => {
						that.data.push(item);
					});
					that.allPage = ob.data.totalPages;//重置总页数
					that.page++;//多加一页
					that.is_empty = false;//为空
					that.loadingFun(2);//关闭加载动画
		        }
			}else if(ob.state==1004){
				//没有更多了
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//没有任何数据
					that.allPage = ob.data.totalPages;//重置总页数
					that.is_empty = false;//为空
					that.loadingFun(3);//关闭加载动画 - 没有更多了(不再请求)
		        }
			}else{
				//请求失败
		        that.$message.showMsgBox({
		            type: 'warning',
		            content: '请求失败'
		        });
		        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
			}
			return ob;
		}).catch(ob=>{
			//请求失败
	        that.$message.showMsgBox({
	            type: 'warning',
	            content: '请求失败'
	        });
	        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
	        return ob;
		});
	},
	//主题队列
	apiZhuantilist(that,obj){
		//请求中
		that.loadingFun(1);
		//执行获取个人信息的请求
		return apiZhuantilist(obj).then(ob=>{
			if(ob.state==1001){
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//请求成功了
					ob.data.list.forEach(item => {
						that.data.push(item);
					});
					that.allPage = ob.data.totalPages;//重置总页数
					that.page++;//多加一页
					that.is_empty = false;//为空
					that.loadingFun(2);//关闭加载动画
		        }
			}else if(ob.state==1004){
				//没有更多了
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//没有任何数据
					that.allPage = ob.data.totalPages;//重置总页数
					that.is_empty = false;//为空
					that.loadingFun(3);//关闭加载动画 - 没有更多了(不再请求)
		        }
			}else{
				//请求失败
		        that.$message.showMsgBox({
		            type: 'warning',
		            content: '请求失败'
		        });
		        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
			}
			return ob;
		}).catch(ob=>{
			//请求失败
	        that.$message.showMsgBox({
	            type: 'warning',
	            content: '请求失败'
	        });
	        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
	        return ob;
		});
	},
	//主题队列
	apiVediolist(that,obj){
		//请求中
		that.loadingFun(1);
		//执行获取个人信息的请求
		return apiVediolist(obj).then(ob=>{
			if(ob.state==1001){
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//请求成功了
					ob.data.list.forEach(item => {
						that.data.push(item);
					});
					that.allPage = ob.data.totalPages;//重置总页数
					that.page++;//多加一页
					that.is_empty = false;//为空
					that.loadingFun(2);//关闭加载动画
		        }
			}else if(ob.state==1004){
				//没有更多了
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//没有任何数据
					that.allPage = ob.data.totalPages;//重置总页数
					that.is_empty = false;//为空
					that.loadingFun(3);//关闭加载动画 - 没有更多了(不再请求)
		        }
			}else{
				//请求失败
		        that.$message.showMsgBox({
		            type: 'warning',
		            content: '请求失败'
		        });
		        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
			}
			return ob;
		}).catch(ob=>{
			//请求失败
	        that.$message.showMsgBox({
	            type: 'warning',
	            content: '请求失败'
	        });
	        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
	        return ob;
		});
	},
	//主题队列
	apiItems(that,obj){
		//请求中
		that.loadingFun(1);
		//执行获取个人信息的请求
		return apiItems(obj).then(ob=>{
			if(ob.state==1001){
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//请求成功了
					ob.data.list.forEach(item => {
						that.data.push(item);
					});
					that.allPage = ob.data.totalPages;//重置总页数
					that.page++;//多加一页
					that.is_empty = false;//为空
					that.loadingFun(2);//关闭加载动画
		        }
			}else if(ob.state==1004){
				//没有更多了
				if(ob.data.totalPages==0){
					//没有任何数据
					that.data = [];//清空
					that.allPage = 1;//重置总页数
					that.page = 1;//重置当前页数
					that.is_empty = true;//为空
					that.loadingFun(3);//关闭加载动画 & 没有更多了(不再请求)
		        }else{
					//没有任何数据
					that.allPage = ob.data.totalPages;//重置总页数
					that.is_empty = false;//为空
					that.loadingFun(3);//关闭加载动画 - 没有更多了(不再请求)
		        }
			}else{
				//请求失败
		        that.$message.showMsgBox({
		            type: 'warning',
		            content: '请求失败'
		        });
		        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
			}
			return ob;
		}).catch(ob=>{
			//请求失败
	        that.$message.showMsgBox({
	            type: 'warning',
	            content: '请求失败'
	        });
	        that.loadingFun(4);//关闭加载动画 - 请求失败了(不再请求)
	        return ob;
		});
	}
}



// WEBPACK FOOTER //
// ./src/util/resultcommons.js